import { FC } from 'react';
import './discoverCarouselContainer.scss';

import { MultiItemsCarousel } from 'components/carousels';
import { IDiscoverSectionTitle } from 'types';
import SectionTitle from '../sectionTitle/SectionTitle';

interface IDiscoverCarouselContainer {
  titles: IDiscoverSectionTitle[];
  children: any;
  settings: any;
  marginTop: number;
  onSeeAllClick(): void;
}

const DiscoverCarouselContainer: FC<IDiscoverCarouselContainer> = ({
  titles,
  marginTop,
  onSeeAllClick,
  settings,
  children,
}) => {
  return (
    <div className="discover-carousel-container" style={{ marginTop }}>
      <div className="slider-header-container">
        <SectionTitle titles={titles} onListClick={onSeeAllClick} />
      </div>
      <MultiItemsCarousel settings={settings} responsiveArrows={false}>
        {children}
      </MultiItemsCarousel>
    </div>
  );
};

export default DiscoverCarouselContainer;
